// CC-63 — Knowledge Base (Drive mirror) API fetchers.
import { API, authHeaders } from "@/lib/api";

async function _json(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    credentials: "include",
    ...options,
    headers: authHeaders({
      "Content-Type": "application/json",
      ...(options.headers || {}),
    }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`${res.status} ${res.statusText}${text ? ` — ${text.slice(0, 200)}` : ""}`);
  }
  return res.json();
}

export const knowledgeApi = {
  getTree: () => _json(`/knowledge/tree`),
  getSyncStatus: () => _json(`/knowledge/sync-status`),
  syncNow: () =>
    _json(`/knowledge/sync-now`, { method: "POST", body: "{}" }),
  // Download URL for use in <a href>. Browser handles the stream.
  downloadUrl: (driveId, format = null) => {
    const qs = format ? `?format=${encodeURIComponent(format)}` : "";
    return `${API}/knowledge/download/${encodeURIComponent(driveId)}${qs}`;
  },
};

export const knowledgeKeys = {
  tree: () => ["knowledge-base", "tree"],
  syncStatus: () => ["knowledge-base", "sync-status"],
};

// Human-readable byte size.
export function formatBytes(bytes) {
  if (bytes == null || Number.isNaN(bytes)) return "";
  const n = Number(bytes);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

// Native-GSuite mime detection (needs the Download-As dropdown).
const GSUITE_SHEET = "application/vnd.google-apps.spreadsheet";
const GSUITE_DOC = "application/vnd.google-apps.document";
const GSUITE_SLIDES = "application/vnd.google-apps.presentation";

export function isGSuiteSheet(mime) { return mime === GSUITE_SHEET; }
export function isGSuiteDoc(mime)   { return mime === GSUITE_DOC; }
export function isGSuiteSlides(mime) { return mime === GSUITE_SLIDES; }
export function isNativeGSuite(mime) {
  return isGSuiteSheet(mime) || isGSuiteDoc(mime) || isGSuiteSlides(mime);
}

export function exportFormatsFor(mime) {
  if (isGSuiteSheet(mime)) return [
    { format: "xlsx", label: "Download as XLSX" },
    { format: "csv",  label: "Download as CSV" },
  ];
  if (isGSuiteDoc(mime)) return [
    { format: "docx", label: "Download as DOCX" },
    { format: "pdf",  label: "Download as PDF" },
  ];
  if (isGSuiteSlides(mime)) return [
    { format: "pptx", label: "Download as PPTX" },
    { format: "pdf",  label: "Download as PDF" },
  ];
  return null;
}
